export const developmentHasBlocks = false
export const masterTexturePath = `${process.env.PUBLIC_URL}/assets/apartmentfinder/textures/`
